export const updateTableMixin = {
    methods: {
        updatePageDataBySearch() {
            if(this.page){
                this.page.currentNum = 1
            }
            this.getData()
        },
        updatePageData() {
            this.getData('deleteSecOrdTag')
        }
    }
}
